import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Message from 'components/parts/message';
import SettingForm from 'components/srv/setting/settingForm';
import { clearMessage, setMessage } from 'actions/messageAction';
import { registProgramSetting } from 'actions/programSettingAction';
import { lang } from 'lang';

/**
 * 調整プログラム登録画面
 */
const SrvProgramRegist = (props) => {
  const { msg, error, word, validate } = lang;
  const { register, handleSubmit, formState, errors } = useForm({mode: 'onChange'});
  const dispatch = useDispatch();

  // グローバルステートから調整プログラム設定を取得する
  const srvSettingState = useSelector((state) => state.programSetting);
  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => {
    // メッセージ初期化
    dispatch(clearMessage());
  }, [React.useRef()]);
  // 登録ボタンが押されたときに実行される
  const onSubmit = async params => {
    // メッセージクリア
    dispatch(clearMessage());

    // 既にプロダクトコードが存在する場合は、エラー
    if ((srvSettingState.items.filter((state) => state.product_cd === params.product_cd)).length > 0) {
      dispatch(setMessage('warning', validate.registered.replace('%s', word.product_cd)));
      return ;
    }
    await dispatch(
      // 調整プログラム設定を登録する
      await registProgramSetting(params)
    ).then((result) => {
      // Success
      if (result.status === 200) {
        props.history.replace({
          pathname: '/srv/settings',
          state: { 
            keepMessage: true,  // 一覧画面表示時にメッセージを残す
            message: {
              type: 'success',
              msg: msg.custom_file.regist,
            }
          }
        });
      // Warning
      } else if (result.status === 400 && result.errcode === 'ITEM_ALREADY_EXISTS') {
        dispatch(setMessage('warning', validate.registered.replace('%s', word.product_cd)));
      // Error
      } else {
        dispatch(setMessage('danger', error.custom_file.regist + `\n${result.errcode}`));
      }
    });
  };
  return (
    <div className="col-10 pt-3 pb-3">
      <Message/>
      <SettingForm isUpdate={false} register={register} onSubmit={handleSubmit(onSubmit)} formState={formState} errors={errors}/>
    </div>
  );
};
SrvProgramRegist.propTypes = {
  history: PropTypes.object
};
export default SrvProgramRegist;